import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React, { useState } from "react";
import Spinner from "../../../../reusableComponents/spinner/spinner";
import { useAppDispatch, useAppSelector } from "../../../../../hooks/hooks";
import { deleteProduct } from "../../../../../store/thunks/systemManagementThunk";

interface DeleteProductDialogProps {
  open: any;
  handleDeleteProductClose: any;
  deleteProductData: any;
}

const DeleteProductDialog = (props: DeleteProductDialogProps) => {
  const dispatch = useAppDispatch();
  const { open, handleDeleteProductClose, deleteProductData } = props;

  const { addProductLoading } = useAppSelector(
    (state: any) => state.systemManagement
  );

  const [deleteProductError, setDeleteProductError] = useState(false);
  const [deleteProductErrorMessage, setDeleteProductErrorMessage] =
    useState("");

  const handleDeleteProduct = (message: string, reason?: any) => {
    if (reason && reason === "backdropClick") {
      return;
    }
    handleDeleteProductClose(message);
  };

  const submitDeleteProduct = () => {
    dispatch(
      deleteProduct({ product_index: deleteProductData?.product_index })
    ).then((result: any) => {
      if (result.payload.result === true) {
        handleDeleteProductClose(result.payload.message);
      } else {
        setDeleteProductError(true);
        setDeleteProductErrorMessage(result.payload.message);
      }
    });
  };

  return (
    <Dialog
      fullWidth={true}
      maxWidth="md"
      onClose={(event, reason) => handleDeleteProduct("", reason)}
      open={open}
      disableEscapeKeyDown={true}
    >
      <DialogTitle
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          backgroundColor: "rgba(59, 147, 74, 1)",
        }}
      >
        <Typography variant="h5" sx={{ fontWeight: "bold", color: "white" }}>
          Delete Product
        </Typography>
        <IconButton
          aria-label="close"
          onClick={() => handleDeleteProduct("")}
          sx={{
            color: "white",
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Spinner loading={addProductLoading} />
      <DialogContent>
        <DialogContentText>
          <Grid
            container
            item
            xs={12}
            sx={{ display: "flex", justifyContent: "center", padding: "10px" }}
          >
            Are you sure that you want to Delete Product:{"  "}
            <span style={{ fontWeight: "bold", padding: "0 5px 0 5px" }}>
              {" "}
              {deleteProductData?.name}{" "}
            </span>
            with Price:
            <span style={{ fontWeight: "bold", padding: "0 5px 0 5px" }}>
              {deleteProductData?.price}
            </span>
          </Grid>
          {deleteProductError && (
            <Grid
              container
              item
              xs={12}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <Typography sx={{ color: "red" }}>
                {deleteProductErrorMessage}
              </Typography>
            </Grid>
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ borderTop: "1px solid" }}>
        <Button
          variant="outlined"
          onClick={() => handleDeleteProduct("")}
          sx={{
            padding: "5px 10px 5px 10px",
            backgroundColor: "red",
            color: "black",
          }}
        >
          Cancel
        </Button>
        <Button
          type="submit"
          variant="outlined"
          sx={{
            padding: "5px 10px 5px 10px",
            backgroundColor: "rgba(59, 147, 74, 1)",
            color: "white",
          }}
          onClick={() => submitDeleteProduct()}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteProductDialog;
